(function() {
    'use strict';

    angular
        .module('eDocumentsApp')
        .controller('UnitOfMeasureDeleteController',UnitOfMeasureDeleteController);

    UnitOfMeasureDeleteController.$inject = ['$uibModalInstance', 'entity', 'UnitOfMeasure'];

    function UnitOfMeasureDeleteController($uibModalInstance, entity, UnitOfMeasure) {
        var vm = this;

        vm.unitOfMeasure = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            UnitOfMeasure.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
